import React from 'react';
import { Link } from 'react-router-dom';
import { APP_LINKS } from '../constants/appLinks';

const VARIANTS = {
  light: 'text-cyan-100 text-xs hover:text-white underline underline-offset-2 transition-colors',
  dark: 'text-guff-blue text-xs hover:text-guff-pink underline underline-offset-2 transition-colors',
  muted: 'text-gray-500 text-xs hover:text-gray-700 underline underline-offset-2 transition-colors',
};

const AppLinksFooter = ({ variant = 'muted', className = '' }) => {
  const linkClass = VARIANTS[variant] || VARIANTS.muted;

  return (
    <div className={`flex items-center justify-center gap-3 flex-wrap ${className}`}>
      <Link to={APP_LINKS.support.path} className={linkClass}>
        {APP_LINKS.support.label}
      </Link>
      <span className="text-gray-400 text-xs">•</span>
      <Link to={APP_LINKS.deleteAccount.path} className={linkClass}>
        {APP_LINKS.deleteAccount.label}
      </Link>
    </div>
  );
};

export default AppLinksFooter;
